import './App.css';
import GamePage from './pages/GamePage';

function App() {
    return (
        <div className="app-container">
            <GamePage />
        </div>
    );
}

export default App;
